
export enum AchievementTypes {
    level = 'level',
    badge = 'badge',
    certification = 'certification'
}
